<template>
    <div id="pause-page">
        <p>
            {{ trans('pages.pause.explanation') }}
        </p>
        <div class="field">
            <ui5-label for="pause">
                {{ trans('pages.pause.pause_duration') }}
            </ui5-label>
            <text-input
                type="number"
                name="pause"
                id="pause"
                value="30"
                :disabled="true"
            />
        </div>
        <ui5-button
            id="enterPause"
            @click="clickTik"
        >
            {{ trans('pages.pause.tick_button') }}
        </ui5-button>
    </div>
</template>

<script>
import Tikklok from '../shared/Tikklok';
import { showInfoMessage } from '../dialogs';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput';

export default {
    mixins: [localization],
    components: { TextInput },
    methods: {
        clickTik() {
            Tikklok.registerPause(() => {
                showInfoMessage(this.trans('pages.pause.pause_registered'));
            });
        },
    },
};
</script>
